import { useQuery } from "@tanstack/react-query";
import { getSiteApplicationDetail } from "services/clients/sites/siteApplications/siteApplicationDetails";

const SITE_APPLICATION_STALE_TIME = 5 * 60 * 1000;

const useSiteApplicationDetail = (siteAppId) => {
	const { data } = useQuery({
		queryKey: ["siteApplicationDetail", siteAppId],
		enabled: Boolean(siteAppId),
		staleTime: SITE_APPLICATION_STALE_TIME,
		queryFn: () => getSiteApplicationDetail(siteAppId),
	});
	return data ?? null;
};

export default useSiteApplicationDetail;
